import { useThemeUI } from '@apia/theme';
import { useRef } from 'react';

const ThemeAssigner = () => {
  const { theme } = useThemeUI();
  const previousTheme = useRef(theme);

  if (theme !== previousTheme.current) {
    previousTheme.current = theme;
    window.currentPalette = theme.palette;
    window.appliedTheme = theme;
  }

  return null;
};

export default ThemeAssigner;
